import Link from 'next/link'

const WellnessBusiness = () => (
    <div className="d-md-flex justify-content-center wellnessBusinessclass pb-5">
        <div className="wellnessNutrition m-3 mb-5">
            <div className="bg-green text-white">
                <p className="mb-0 p-3 h5"><strong>Wellness & Nutrition</strong></p>
                <img src="/images/classes/img-wellness-and-nutrition-a01.jpg" className="img-fluid"/>
            </div>
            <Link href="/classes-and-programs/wellnessclass"><a className="rounded-pill text-white btn-green px-5 py-2 my-3 d-inline-block h7 btnview"><strong>VIEW</strong></a></Link>
        </div>
        <div className="businessLifestyle m-3">
            <div className="bg-blue text-white">
                <p className="mb-0 p-3 h5"><strong>Business & Lifestyle</strong></p>
                <img src="/images/classes/img-business-and-lifestyle-a01.jpg" className="img-fluid"/>
            </div>
            <Link href="/business-classes"><a className="text-white btn-blue px-5 py-2 my-3 d-inline-block h7 rounded-pill btnview"><strong>VIEW</strong></a></Link>
        </div>
        <style jsx>{`
            @media (min-width:768px){
                .wellnessBusinessclass img{
                    width:471px;
                    height:294px;
                }
            }
        `}</style>
    </div>
);
export default WellnessBusiness;